import { render, staticRenderFns } from "./warehouseTypeIcon.vue?vue&type=template&id=2f7cd7de&scoped=true"
import script from "./warehouseTypeIcon.vue?vue&type=script&lang=js"
export * from "./warehouseTypeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7cd7de",
  null
  
)

export default component.exports